import { DetailedIconChecklist } from '@zillow/constellation';
import { Box, Button } from '@zillow/constellation-10';
import ConnectedModuleCard from '../../../ConnectedModuleCard';

import { StyledEmptyIconContainer, StyledEmptyStateContainer } from '../../../../StyledComponents';
import { EmptyStateBodyText, EmptyStateTitleText } from '../../../../styles';

type Props = {
  title: string;
  description: string;
  actionUrl: string;
  actionText: string;
};

const EmptyPropertyConditionModule = ({ title, description, actionUrl, actionText }: Props) => {
  const hideBorder = true;

  return (
    <ConnectedModuleCard data-testid="EmptyPropertyConditionModule">
      <StyledEmptyStateContainer>
        <StyledEmptyIconContainer>
          <DetailedIconChecklist />
        </StyledEmptyIconContainer>
        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>
        <EmptyStateBodyText asChild>
          <p>{description}</p>
        </EmptyStateBodyText>
        <Box css={{ marginBottom: '600' }} />
        <Button asChild size="md" tone="brand" emphasis="filled">
          <a href={actionUrl}>{actionText}</a>
        </Button>
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default EmptyPropertyConditionModule;
